import {Pipe, PipeTransform} from '@angular/core';
import {FilterSpecsBySourcePipe, IWithSpecs, SpecLineModel} from "web-shared";
import {ClassificatorValueQuery, GroupByValuesPipe, PropertyQuery} from "common-shared";
import {SpecLinesEditColumns, TableColumn} from "../../../core/table-column";

@Pipe({
  name: 'filterAndGroupAndSortSpecs'
})
export class FilterAndGroupAndSortSpecsPipe implements PipeTransform {
  constructor(private groupByValuesPipe: GroupByValuesPipe, private filterSpecsBySourcePipe: FilterSpecsBySourcePipe) {
  }

  transform(specs: SpecLineModel[], container: IWithSpecs, showOwnProperties: boolean, showLocalization: boolean, propertyGroups: ClassificatorValueQuery[], properties: PropertyQuery[], toggleableColumns: TableColumn<SpecLinesEditColumns>[]): SpecLineModel[] {
    let filteredSpecs = showOwnProperties ? this.filterSpecsBySourcePipe.transform(specs, container as any) : specs;
    filteredSpecs = showLocalization ? filteredSpecs : filteredSpecs.filter(spec => !spec.LanguageId || spec.ShowLocalization);

    if(toggleableColumns != null){
      let originColumn = toggleableColumns.find(value => value.Identifier == SpecLinesEditColumns.Origin);
      if(originColumn){
        let idTextModelStates = originColumn.Values.filter(value => value.State == true);
        filteredSpecs = filteredSpecs.filter(spec => idTextModelStates.find(value1 => value1.Id == spec.OriginClv || !spec.OriginClv))
      }
    }

    const groupsByProperty = this.groupByValuesPipe.transform(filteredSpecs, 'PropertyId');
    const sortedValues: SpecLineModel[] = [];
    groupsByProperty.forEach(group => {
      group.sort((a, b) => {
        return !a.LanguageId ? -1 : 1;
      });
      group.forEach(spec => {
        const groupClv = spec.GroupClv ?? properties?.find(property => property.Id === spec.PropertyId)?.GroupClv;
        const propertyGroup = propertyGroups?.find(clv => clv.Id === groupClv);
        spec.RowGroupKey = propertyGroup ? `${propertyGroup.Sequence}|${propertyGroup.DisplayName}|${propertyGroup.Id}` : undefined;
        spec.Group = propertyGroup ? propertyGroup.DisplayName : '-';
        sortedValues.push(spec);
      });
    });
    return sortedValues;
  }
}
